import {
  BackgroundLevelProvider,
  Button,
  CardSelector,
  CardSelectorGroup
} from '@themenu/design-system'

import { logger } from 'lib/analytics/logger'
import { dispatchToaster } from 'lib/utils/notifications'

import { useSessionStore } from 'store/session'
import { useSendSurveyAnswerMutation } from 'providers/corporate-surveys/useSendSurveyAnswerMutation'

import { useRecardingPreferenceSurveyStore } from '../../store'
import { AxiosError, isAxiosError } from 'axios'
import { buildAxiosErrorContext } from 'lib/analytics/helpers/buildAxiosErrorContext'
import { eventSenderManager } from 'lib/analytics/eventSender'

export const RecardingPreferenceQuestionStep = () => {
  const { user } = useSessionStore()
  const { recardingPreferenceAnswer, setRecardingPreferenceAnswer, setStep } =
    useRecardingPreferenceSurveyStore()

  const { trigger: sendSurveyAnswer, isMutating: isSendingSurveyAnswer } =
    useSendSurveyAnswerMutation()

  const handleNext = async () => {
    try {
      await sendSurveyAnswer({
        surveyType: 'RECARDING_PREFERENCE',
        response:
          recardingPreferenceAnswer as Enum.CorporateSurveyRecardingPreferenceResponse,
        answeredBy: user.name
      })

      eventSenderManager.sendEvent({
        label: 'recarding preference survey answer submission successful',
        metadata: {
          response: recardingPreferenceAnswer
        }
      })

      setStep('success')
    } catch (error) {
      const { responseData } = buildAxiosErrorContext(error as AxiosError)

      eventSenderManager.sendEvent({
        label: 'recarding preference survey answer submission failed',
        metadata: {
          ...responseData,
          error: error as AxiosError
        }
      })
      logger.error(
        'Error submitting recarding preference survey answer',
        {},
        error
      )

      let errorMessage =
        'Ocorreu um erro ao enviar a resposta. Por favor, tente novamente.'

      if (isAxiosError(error)) {
        if (error.response?.status === 409) {
          errorMessage =
            'Agradecemos o interesse, mas essa pesquisa já foi respondida pela sua empresa! Você pode fechar essa modal e continuar usando a plataforma.'
        }
      }

      dispatchToaster({
        title: 'Oops!',
        message: errorMessage,
        variant: 'error'
      })
    }
  }

  return (
    <div className="flex flex-col gap-32 overflow-y-auto">
      <BackgroundLevelProvider backgroundLevel={'level0'}>
        <CardSelectorGroup
          value={recardingPreferenceAnswer}
          onChange={(newValue: string) =>
            setRecardingPreferenceAnswer(
              newValue as Enum.CorporateSurveyRecardingPreferenceResponse
            )
          }
        >
          <div className="flex flex-col gap-16">
            <CardSelector
              value="AUTOMATIC"
              title="Envio automático para a casa dos colaboradores"
              subtitle="Enviamos automaticamente os cartões para o endereço confirmado pelo colaborador no app."
              description="Ideal para: Times remotos ou para reduzir a carga operacional do RH"
              disabled={false}
            />
            <CardSelector
              value="MANUAL"
              title="Solicitação manual via Dashboard"
              subtitle="Você solicita a troca pela plataforma e escolhe o destino (em lote para a empresa ou direto para a casa do colaborador)."
              description="Ideal para: Times presenciais ou para manter a organização de quem recebe e como."
              disabled={false}
            />
          </div>
        </CardSelectorGroup>
      </BackgroundLevelProvider>

      <div className="flex justify-center">
        <Button
          size={40}
          endIcon="arrow-right"
          onClick={handleNext}
          loading={isSendingSurveyAnswer}
          disabled={!recardingPreferenceAnswer}
        >
          Prosseguir
        </Button>
      </div>
    </div>
  )
}
